module.exports = __webpack_public_path__ + "img/IMG_9033_L_Wood.efb1be41.jpg";